import React from 'react';


import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const formatCurrency = (val) => {
  if (val == null || isNaN(val)) return '$0';
  return `$${Number(val).toLocaleString()}`;
};

const formatShortCurrency = (val) => {
  if (val >= 1_000_000) return `$${(val / 1_000_000).toFixed(2)}M`;
  if (val >= 1_000) return `$${(val / 1_000).toFixed(0)}K`;
  return `$${Math.round(val)}`;
};


const RentToOwnYearlyChart = ({ yearlyData }) => {
  if (!yearlyData || yearlyData.length === 0) {
    return <div className="text-center text-gray-500">No yearly chart data available.</div>;
  }

  return (
    <div className="bg-white shadow-md rounded-lg p-6 mt-8">
      <h2 className="text-xl font-bold text-center text-blue-700 mb-6">
        Rent-to-Own Yearly Ownership, Value & Expenses
      </h2>

      <ResponsiveContainer width="100%" height={500}>
        <ComposedChart
          data={yearlyData}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis tickFormatter={(val) => `$${val / 1000}k`} />
          <Tooltip formatter={(val) => formatCurrency(val)} />
          <Legend />

          {/* Stacked bars for expenses */}
          <Bar dataKey="investorEquity" stackId="expenses" fill="#FF6384" opacity={0.6} name="Investor Equity" />
          <Bar dataKey="entrepreneurEquity" stackId="expenses" fill="#36a2eb"  opacity={0.6} name="Entrepreneur Equity" />
          <Bar dataKey="cumulativeInvestorExpenses" stackId="expenses" fill="#facc15" name="Investor Expense" />
          {/* <Bar dataKey="investorInsurance" stackId="expenses" fill="#60a5fa" name="Investor Insurance" />
          <Bar dataKey="investorMaintenance" stackId="expenses" fill="#4ade80" name="Investor Maintenance" /> */}

          <Bar dataKey="cumulativeInvestorExpenses" stackId="expenses" fill="#a78bfa" name="Entrepreneur Expenses" />
          {/* <Bar dataKey="entrepreneurInsurance" stackId="expenses" fill="#fbbf24" name="Entrepreneur Insurance" />
          <Bar dataKey="entrepreneurMaintenance" stackId="expenses" fill="#f87171" name="Entrepreneur Maintenance" /> */}
          {/* <Bar dataKey="cumulativeNetRentIncome" stackId="expenses" fill="#a78bfa" name="Net Rent Income" /> */}
          {/* <Bar dataKey="cumulativeEquityBuyout" stackId="expenses" fill="#a78bfa" name="Equity Buyout" /> */}
          
          {/* <Bar dataKey="cumulativeNetRentIncome" stackId="expenses" fill="#FF6384" name="Investor Net Income" /> */}

          {/* Equity and value tracking lines #36a2eb #2563eb #FF6384 #7E22CE*/}
          {/* <Line type="monotone" dataKey="investorEquity" stroke="#2563eb" strokeWidth={2} name="Investor Equity" />
          <Line type="monotone" dataKey="entrepreneurEquity" stroke="#7E22CE" strokeWidth={2} name="Entrepreneur Equity" /> */}
          <Line type="monotone" dataKey="assetValue" stroke="#0f172a" strokeWidth={2} name="Asset Value">  <LabelList
            dataKey="assetValue"
            position="top"
            content={({ x, y, value, index }) =>
              index === yearlyData.length - 1 ? (
                <text x={x - 6} y={y - 14} fill="#0f172a" textAnchor="middle"  fontSize={12} fontWeight="bold">
                  Asset: {formatShortCurrency(value)}
                </text>
              ) : null
            }
          />
          </Line>
          <Line type="monotone" dataKey="investorNetCashflow" stroke="#0f172a" strokeWidth={2} name="Net Income Value" />
          <Line type="monotone" dataKey="investorExitValue" stroke="#2563eb" strokeWidth={2} strokeDasharray="4 2" name="Investor Exit Value">
            <LabelList
              dataKey="investorExitValue"
              position="left"
              content={({ x, y, value, index }) =>
                index === yearlyData.length - 1 ? (
                  <text x={x - 6} y={y + 14} fill="#2563eb" textAnchor="middle"  fontSize={12} fontWeight="bold">
                    Invs Exit: {formatShortCurrency(value)}
                  </text>
                ) : null
              }
            />
          </Line>
          <Line type="monotone" dataKey="entrepreneurExitValue" stroke="#7E22CE" strokeWidth={2} strokeDasharray="4 2" name="Entrepreneur Exit Value">
            <LabelList
              dataKey="entrepreneurExitValue"
              position="bottom"
              content={({ x, y, value, index }) =>
                index === yearlyData.length - 1 ? (
                  <text x={x - 6} y={y - 14} fill="#7E22CE" textAnchor="middle"  fontSize={12} fontWeight="bold">
                    Entr Exit: {formatShortCurrency(value)}
                  </text>
                ) : null
              }
            />

          </Line>






        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RentToOwnYearlyChart;
